<div class="popup-close" mat-dialog-close>
  <svg viewBox="0 0 14 14">
    <use href="#close" />
  </svg>
</div>
<h1 mat-dialog-title class="popup-title"><span i18n>Settings</span></h1>
<div mat-dialog-content>
  <div class="stream-wrapper">
    <app-video [stream]="sStream$ | async"></app-video>
  </div>

  <div class="field-wrap">
    <div class="field-label">
      <div class="d-flex w-100">
        <div class="col-6"><span i18n>Video input</span></div>
        <div class="col-6">
          <mat-slide-toggle
            [checked]="videoInputDeviceIsFlipped$ | async"
            (change)="onVideoInputDeviceIsFlippedSet($event.checked)"
          >
            <div class="flip-title">
              <span i18n>Flip</span>
              <svg-icon
                name="information"
                class="icon icon-black"
                i18n-matTooltip
                matTooltipClass="mat-tooltip-multiline"
                matTooltip="Flip the video horizontally"
              ></svg-icon>
            </div>
          </mat-slide-toggle>
        </div>
      </div>
    </div>
    <mat-form-field appearance="fill">
      <mat-select (selectionChange)="onVideoInputDeviceIdSet($event.value)" [value]="videoInputDeviceId$ | async">
        <mat-option
          [value]="device.deviceId"
          *ngFor="let device of videoInputDevices$ | async"
          [matTooltip]="device.label + ' - ' + device.deviceId"
        >
          {{ device.label }} - {{ device.deviceId }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="field-wrap">
    <div class="field-label">
      <div class="d-flex w-100">
        <div class="col-6"><span i18n>Video resolution</span></div>
        <div class="col-6 video-resolution-warning" *ngIf="videoInputResolutionRequiresCapableDeviceToRun$ | async">
          <svg-icon name="warning" class="icon"></svg-icon>
          Requires a capable device to run
        </div>
      </div>
    </div>
    <mat-form-field appearance="fill">
      <mat-select (selectionChange)="onVideoInputResolutionSet($event.value)" [value]="videoInputResolution$ | async">
        <mat-option [value]="resolution.value" *ngFor="let resolution of RESOLUTIONS" [matTooltip]="resolution.title">
          {{ resolution.title }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="field-wrap">
    <div class="field-label">
      <div class="d-flex w-100">
        <div class="col-6"><span i18n>Audio input</span></div>
        <div class="col-6" #audioInputWaveFormRef></div>
      </div>
    </div>
    <mat-form-field appearance="fill">
      <mat-select (selectionChange)="onAudioInputDeviceIdSet($event.value)" [value]="audioInputDeviceId$ | async">
        <mat-option
          [value]="device.deviceId"
          *ngFor="let device of audioInputDevices$ | async"
          [matTooltip]="device.label + ' - ' + device.deviceId"
        >
          {{ device.label }} - {{ device.deviceId }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="field-wrap" *ngIf="audioOutputDeviceIsSupported">
    <div class="field-label">
      <div class="d-flex w-100">
        <div class="col-6"><span i18n>Audio output</span></div>
        <div class="col-6" *ngIf="audioOutputDeviceId$ | async as audioOutputDeviceId">
          <svg-icon
            (click)="onAudioOutputDeviceTest(audioOutputDeviceId); false"
            name="volume-orange"
            class="icon"
          ></svg-icon>
          Test
        </div>
      </div>
    </div>
    <mat-form-field appearance="fill">
      <mat-select (selectionChange)="onAudioOutputDeviceIdSet($event.value)" [value]="audioOutputDeviceId$ | async">
        <mat-option
          [value]="device.deviceId"
          *ngFor="let device of audioOutputDevices$ | async"
          [matTooltip]="device.label + ' - ' + device.deviceId"
        >
          {{ device.label }} - {{ device.deviceId }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="details-wrap" *ngIf="details$ | async as details">
    <div class="details-toggler">
      <span (click)="onDetailsRenderToggle(); false"><span i18n>Details</span></span>
      <svg-icon
        name="copy"
        (mouseleave)="onDetailsUnCopied(); false"
        (click)="onDetailsCopied(); false"
        matTooltip="Copy stream details"
        i18n-matTooltip
        [cdkCopyToClipboard]="details"
      ></svg-icon>
      <ng-container *ngIf="detailsCopied$ | async">Copied!</ng-container>
    </div>
    <div class="details-data" *ngIf="detailsRender$ | async"> {{ details }} </div>
  </div>
</div>
<audio #audioOutputDeviceTestRef src="assets/audio/beep1.mp3"></audio>
